// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-documents{padding:50px 0;text-align:left}.empty-documents__helper{position:absolute;top:-10px;right:35px}.empty-documents__helper-text{position:absolute}.empty-documents__notification{background:url(\"https://s3.amazonaws.com/static-public-v3-uudev/assets/app-client/empty_docs_2x.png\") no-repeat center center;background-size:245px 216px;padding-top:245px;width:100%}.empty-documents__notification-text{position:absolute;bottom:0;left:50%;transform:translateX(-50%)}", ""]);
// Exports
module.exports = exports;
